<template>
  <div>
    <!--查询条件-->
    <wsPanel v-if="showQuery" class="panel-query">
      <div slot="panel_body" v-show="showQueryForm">
        <div class="panel-query-form">
          <slot name="query_form"></slot>
        </div>
      </div>
    </wsPanel>

    <!--数据区域-->
    <wsPanel>
      <div slot="panel_head_title">
        <Icon type="navicon-round" size="20"></Icon>
        <span>{{dataTitle}}</span>
      </div>
      <div slot="panel_head_operate">
        <slot name="list_operate"></slot>
      </div>
      <div slot="panel_body">
        <slot name="list_data"></slot>
      </div>
      <div slot="panel_bottom" v-if="page">
        <div class="panel-page">
          <Page
            :current="page.pageNum"
            :total="page.total"
            :page-size="page.pageSize"
            :page-size-opts="pageSizeOpts"
            placement="top"
            show-sizer
            show-total
            size="small"
            @on-change="pageChange"
            @on-page-size-change="pageSizeChange"
          ></Page>
        </div>
      </div>
    </wsPanel>
  </div>
</template>

<script>
import wsPanel from "../../panel/";
export default {
  components: {
    wsPanel
  },
  props: {
    //是否显示高级查询
    showHighQuery: {
      type: Boolean,
      default: false
    },
    page: {
      type: Object
    },
    //数据列表的title
    dataTitle: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      showQueryForm: true,
      pageSizeOpts: [10, 20, 30, 40, 100, 1000]
    };
  },
  mounted() {},
  computed: {
    /**
     * 是否显示查询区域(根据查询区域的FORM表单是否存在处理)
     */
    showQuery() {
      return this.$slots.query_form !== undefined;
    }
  },
  methods: {
    //切换查询面板显示隐藏
    arrowToggle() {
      this.showQueryForm = !this.showQueryForm;
    },
    //高级查询
    highQuery() {
      this.$emit("high-query");
    },
    //简单查询
    simpleQuery() {
      this.$emit("simple-query");
    },
    //分页改变
    pageChange(pageIndex) {
      this.page.pageNum = pageIndex;
      this.$emit("page-change", this.page);
    },
    //分页条数改变事件
    pageSizeChange(pageSize) {
      this.page.pageSize = pageSize;
      //同时会触发分页改变事件，此处不需要单独发送消息
      this.$emit("page-change", this.page);
    }
  }
};
</script>

<style scoped lang="stylus">
  /*.panel-query >>> .panel-heading*/
     /*display none*/
  panel-query >>>.panel-body
    padding-top 10px
    background #F2F5FC !important


.panel-query {
  /*margin-bottom: 15px;*/
}
.panel-query-form {
  padding-top: 10px;
  padding-bottom 10px
  /*padding: 20px 15px 0 15px;*/
  box-sizing: border-box;
  padding-left: 20px;
}
.panel-operate-arrow {
  margin-right: 15px;
  cursor: pointer;
}
.panel-page {
  float: right;
}
.ivu-icon + span {
  margin-left: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/smPanel/src/smPanel.vue